<ud-breadcrumbs class="max-w-full" [items]="menuItems"></ud-breadcrumbs>
